import Phaser from 'phaser';
import { sounds } from '../audio/SoundEffects';
import { progression } from '../game/Progression';
import { ShopModal } from '../ui/ShopModal';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MenuScene' });
  }

  create() {
    console.log('[MenuScene] create start');
    const { width, height } = this.scale;

    // Background Image: Zelvis King of Rock 'n Olympus
    if (this.textures.exists('zelvis_hero')) {
      const bg = this.add.image(width / 2, height / 2, 'zelvis_hero');
      const scaleX = width / bg.width;
      const scaleY = height / bg.height;
      const scale = Math.max(scaleX, scaleY);
      bg.setScale(scale);
      bg.setAlpha(0.72);
    }

    // Dark gradient overlay for readability
    const overlay = this.add.graphics();
    overlay.fillGradientStyle(0x0f172a, 0x0f172a, 0x020617, 0x020617, 0.4, 0.4, 0.95, 0.95);
    overlay.fillRect(0, 0, width, height);

    // Audio Mute/Unmute Toggle in top-right corner
    const isMuted = sounds.isMuted;
    const soundToggle = this.add.text(width - 24, 24, isMuted ? '🔇' : '🔊', {
      fontSize: '28px',
      backgroundColor: '#1e293b',
      padding: { x: 8, y: 6 }
    }).setOrigin(1, 0).setInteractive({ useHandCursor: true });

    soundToggle.on('pointerdown', () => {
      sounds.isMuted = !sounds.isMuted;
      sounds.music.setMuted(sounds.isMuted);
      soundToggle.setText(sounds.isMuted ? '🔇' : '🔊');
    });

    // APK Download button in top-left corner
    const apkButton = this.add.text(24, 24, '📱 APK', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '15px',
      fontStyle: 'bold',
      color: '#38bdf8',
      backgroundColor: '#1e293b',
      padding: { x: 10, y: 8 }
    }).setOrigin(0, 0).setInteractive({ useHandCursor: true });

    apkButton.on('pointerdown', () => {
      window.open('zelvis-antigravity.apk', '_blank');
    });

    // Title Banner
    const titleGlow = this.add.text(width / 2, 95, 'ZELVIS', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '50px',
      color: '#facc15',
      stroke: '#b45309',
      strokeThickness: 8,
      align: 'center'
    }).setOrigin(0.5);

    this.tweens.add({
      targets: titleGlow,
      scaleX: 1.05,
      scaleY: 1.05,
      duration: 1000,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    this.add.text(width / 2, 142, 'ANTI-GRAVITY', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '28px',
      color: '#38bdf8',
      stroke: '#0369a1',
      strokeThickness: 6,
      letterSpacing: 4,
      align: 'center'
    }).setOrigin(0.5);

    this.add.text(width / 2, 178, "KING OF ROCK 'N OLYMPUS", {
      fontFamily: 'Arial, sans-serif',
      fontSize: '13px',
      color: '#fbbf24',
      fontStyle: 'bold',
      letterSpacing: 2,
      align: 'center'
    }).setOrigin(0.5);

    // High Score & Bank Header
    const highScore = localStorage.getItem('zelvis_highscore') || '0';
    this.add.text(width / 2, 218, `🏆 RECORD: ${highScore} PTS  |  📀 BANK: ${progression.getBankVinyls()}`, {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      color: '#ffffff',
      fontStyle: 'bold',
      backgroundColor: 'rgba(0, 0, 0, 0.65)',
      padding: { x: 14, y: 5 }
    }).setOrigin(0.5);

    // LEVEL SELECTION PANEL (Act 1: 1-4, Act 2: 5-8, Act 3: 9-11)
    this.currentAct = 1;

    const colLeft = width / 2 - 98;
    const colRight = width / 2 + 98;

    // Act Selector Tabs (3 Acts)
    const tabY = 256;
    const tabAct1 = this.add.container(width / 2 - 130, tabY);
    const tabAct1Bg = this.add.rectangle(0, 0, 122, 34, 0x0284c7, 1).setStrokeStyle(2, 0x38bdf8, 1).setInteractive({ useHandCursor: true });
    const tabAct1Text = this.add.text(0, 0, '⚡ ACT I (1-4)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '13px',
      color: '#ffffff'
    }).setOrigin(0.5);
    tabAct1.add([tabAct1Bg, tabAct1Text]);

    const tabAct2 = this.add.container(width / 2, tabY);
    const tabAct2Bg = this.add.rectangle(0, 0, 122, 34, 0x1e293b, 1).setStrokeStyle(2, 0x64748b, 1).setInteractive({ useHandCursor: true });
    const tabAct2Text = this.add.text(0, 0, '🌌 ACT II (5-8)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '13px',
      color: '#94a3b8'
    }).setOrigin(0.5);
    tabAct2.add([tabAct2Bg, tabAct2Text]);

    const tabAct3 = this.add.container(width / 2 + 130, tabY);
    const tabAct3Bg = this.add.rectangle(0, 0, 122, 34, 0x1e293b, 1).setStrokeStyle(2, 0x64748b, 1).setInteractive({ useHandCursor: true });
    const tabAct3Text = this.add.text(0, 0, '👑 ACT III (9-11)', {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: '13px',
      color: '#94a3b8'
    }).setOrigin(0.5);
    tabAct3.add([tabAct3Bg, tabAct3Text]);

    // Container for Act 1 buttons
    this.act1Container = this.add.container(0, 0);

    // Button: LEVEL 1 (OLYMPUS ARENA)
    this.act1Container.add(this.createLevelButton(
      colLeft,
      314,
      'STAGE 1: OLYMPUS',
      '⚡ Sky Arena & Marble',
      0x0284c7,
      0x38bdf8,
      () => this.startLevel(1),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 2 (TARTARUS ABYSS)
    this.act1Container.add(this.createLevelButton(
      colRight,
      314,
      'STAGE 2: TARTARUS',
      '🔥 Obsidian Metal Rave',
      0x7e22ce,
      0xc026d3,
      () => this.startLevel(2),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 3 (HEPHAESTUS CYBER-FORGE)
    this.act1Container.add(this.createLevelButton(
      colLeft,
      382,
      'STAGE 3: CYBER FORGE',
      '🔨 Molten Bronze & Gears',
      0xc2410c,
      0xf97316,
      () => this.startLevel(3),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 4 (COSMIC OLYMPUS APOTHEOSIS)
    this.act1Container.add(this.createLevelButton(
      colRight,
      382,
      'STAGE 4: COSMOS',
      '🌌 Celestial Apotheosis',
      0x4338ca,
      0x818cf8,
      () => this.startLevel(4),
      188,
      60,
      '15px'
    ));

    // Container for Act 2 buttons
    this.act2Container = this.add.container(0, 0);
    this.act2Container.setVisible(false);

    // Button: LEVEL 5 (ATLANTIS NEON ABYSS)
    this.act2Container.add(this.createLevelButton(
      colLeft,
      314,
      'STAGE 5: ATLANTIS',
      '🌊 Cyber Ocean & Coral',
      0x0891b2,
      0x22d3ee,
      () => this.startLevel(5),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 6 (DIONYSUS NEON RAVE)
    this.act2Container.add(this.createLevelButton(
      colRight,
      314,
      'STAGE 6: DIONYSUS',
      '🍇 Neon Rave & Synth-Wine',
      0x9333ea,
      0xfacc15,
      () => this.startLevel(6),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 7 (ARES ORBITAL CITADEL)
    this.act2Container.add(this.createLevelButton(
      colLeft,
      382,
      'STAGE 7: ARES CITADEL',
      '⚔️ War Fortress & Plasma',
      0xb91c1c,
      0xef4444,
      () => this.startLevel(7),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 8 (KRONOS CHRONO-SINGULARITY)
    this.act2Container.add(this.createLevelButton(
      colRight,
      382,
      'STAGE 8: KRONOS',
      '⌛ Chrono-Singularity Climax',
      0xb45309,
      0xfde047,
      () => this.startLevel(8),
      188,
      60,
      '14.5px'
    ));

    // Container for Act 3 buttons (Stages 9, 10, 11)
    this.act3Container = this.add.container(0, 0);
    this.act3Container.setVisible(false);

    // Button: LEVEL 9 (RIVER STYX SPECTRAL RUN)
    this.act3Container.add(this.createLevelButton(
      colLeft,
      314,
      'STAGE 9: STYX',
      '💀 Spectral River & Wraith',
      0x065f46,
      0x10b981,
      () => this.startLevel(9),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 10 (APOLLO SOLAR HYPER-DRIVE)
    this.act3Container.add(this.createLevelButton(
      colRight,
      314,
      'STAGE 10: APOLLO',
      '☀️ Helios Solar Flare',
      0xb45309,
      0xf59e0b,
      () => this.startLevel(10),
      188,
      60,
      '15px'
    ));

    // Button: LEVEL 11 (CHAOS PRIMORDIAL GENESIS)
    this.act3Container.add(this.createLevelButton(
      width / 2,
      382,
      'STAGE 11: CHAOS GENESIS',
      '👑 Primordial Big Bang Climax',
      0x581c87,
      0xa855f7,
      () => this.startLevel(11),
      386,
      60,
      '17px'
    ));

    const switchAct = (actNum) => {
      this.currentAct = actNum;
      sounds.playCoin();

      [tabAct1Bg, tabAct2Bg, tabAct3Bg].forEach(bg => bg.setFillStyle(0x1e293b, 1).setStrokeStyle(2, 0x64748b, 1));
      [tabAct1Text, tabAct2Text, tabAct3Text].forEach(t => t.setColor('#94a3b8'));
      this.act1Container.setVisible(false);
      this.act2Container.setVisible(false);
      this.act3Container.setVisible(false);

      if (actNum === 1) {
        tabAct1Bg.setFillStyle(0x0284c7, 1).setStrokeStyle(2, 0x38bdf8, 1);
        tabAct1Text.setColor('#ffffff');
        this.act1Container.setVisible(true);
      } else if (actNum === 2) {
        tabAct2Bg.setFillStyle(0x7e22ce, 1).setStrokeStyle(2, 0xfacc15, 1);
        tabAct2Text.setColor('#ffffff');
        this.act2Container.setVisible(true);
      } else if (actNum === 3) {
        tabAct3Bg.setFillStyle(0x065f46, 1).setStrokeStyle(2, 0x34d399, 1);
        tabAct3Text.setColor('#ffffff');
        this.act3Container.setVisible(true);
      }
    };

    tabAct1Bg.on('pointerdown', () => switchAct(1));
    tabAct1Text.setInteractive({ useHandCursor: true }).on('pointerdown', () => switchAct(1));
    tabAct2Bg.on('pointerdown', () => switchAct(2));
    tabAct2Text.setInteractive({ useHandCursor: true }).on('pointerdown', () => switchAct(2));
    tabAct3Bg.on('pointerdown', () => switchAct(3));
    tabAct3Text.setInteractive({ useHandCursor: true }).on('pointerdown', () => switchAct(3));

    // Button: ROCKSTAR PERK SHOP & MISSIONS
    this.createLevelButton(
      width / 2,
      452,
      `🛍️ ROCKSTAR SHOP (📀 ${progression.getBankVinyls()})`,
      'Perks: Shield, Magnet, Overdrive & Missions',
      0xb45309,
      0xfacc15,
      () => new ShopModal(this, () => this.scene.restart()),
      386,
      56,
      '18px'
    );

    // Gameplay guide box
    const guideBox = this.add.graphics();
    guideBox.fillStyle(0x0f172a, 0.88);
    guideBox.fillRoundedRect(width / 2 - 180, height - 215, 360, 125, 14);
    guideBox.lineStyle(2, 0x38bdf8, 0.8);
    guideBox.strokeRoundedRect(width / 2 - 180, height - 215, 360, 125, 14);

    this.add.text(width / 2, height - 200, '⚡ HOW TO PLAY & WIN ⚡', {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      color: '#facc15',
      fontStyle: 'bold'
    }).setOrigin(0.5);

    const hints = [
      '• Tap [ANTI-GRAVITY] or Space to flip gravity',
      '• Tap [SLIDE] to knee-slide under hazards',
      '• Fill Overdrive (100%) to SHRED through spikes!',
      '• Graze near hazards for CLOSE CALL combos!'
    ];

    hints.forEach((hint, idx) => {
      this.add.text(width / 2 - 165, height - 176 + (idx * 21), hint, {
        fontFamily: 'Arial, sans-serif',
        fontSize: '11.5px',
        color: '#e2e8f0'
      });
    });

    // Keyboard support
    this.input.keyboard.on('keydown-ONE', () => this.startLevel(1));
    this.input.keyboard.on('keydown-TWO', () => this.startLevel(2));
    this.input.keyboard.on('keydown-THREE', () => this.startLevel(3));
    this.input.keyboard.on('keydown-FOUR', () => this.startLevel(4));
    this.input.keyboard.on('keydown-FIVE', () => this.startLevel(5));
    this.input.keyboard.on('keydown-SIX', () => this.startLevel(6));
    this.input.keyboard.on('keydown-SEVEN', () => this.startLevel(7));
    this.input.keyboard.on('keydown-EIGHT', () => this.startLevel(8));
    this.input.keyboard.on('keydown-NINE', () => this.startLevel(9));
    this.input.keyboard.on('keydown-ZERO', () => this.startLevel(10));
    this.input.keyboard.on('keydown-P', () => this.startLevel(11));
    this.input.keyboard.on('keydown-SPACE', () => this.startLevel(1));
    this.input.keyboard.on('keydown-ENTER', () => this.startLevel(1));
  }

  createLevelButton(x, y, title, subtitle, color, borderColor, onClick, btnWidth = 340, btnHeight = 74, titleSize = '22px') {
    const btn = this.add.container(x, y);

    // Clickable background rectangle
    const bg = this.add.rectangle(0, 0, btnWidth, btnHeight, color, 0.95);
    bg.setStrokeStyle(3, borderColor, 1);
    bg.setInteractive({ useHandCursor: true });

    const t = this.add.text(0, -9, title, {
      fontFamily: 'Impact, Arial Black, sans-serif',
      fontSize: titleSize,
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 2
    }).setOrigin(0.5);

    const sub = this.add.text(0, 14, subtitle, {
      fontFamily: 'Arial, sans-serif',
      fontSize: '11.5px',
      color: '#fef08a'
    }).setOrigin(0.5);

    btn.add([bg, t, sub]);

    const triggerClick = () => {
      btn.setScale(0.94);
      this.time.delayedCall(80, () => {
        btn.setScale(1.0);
        onClick();
      });
    };

    bg.on('pointerdown', triggerClick);
    t.setInteractive({ useHandCursor: true }).on('pointerdown', triggerClick);
    sub.setInteractive({ useHandCursor: true }).on('pointerdown', triggerClick);

    this.tweens.add({
      targets: btn,
      scaleX: 1.03,
      scaleY: 1.03,
      duration: 800 + Math.random() * 200,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut'
    });

    return btn;
  }

  startLevel(levelNumber) {
    sounds.init();
    sounds.playRockChord();
    this.scene.start('GameScene', { level: levelNumber });
  }
}
